import axios from 'axios';
import { getBackendHost } from '../utils/backendHost';


const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}`,
  },
});


export async function getKnowledgeSources(params = {}) {
  const response = await axios.get(
    `${getBackendHost()}/v2/knowledge/sources`,
    { ...authConfig(), params },
  );
  return response.data;
}


export async function publishKnowledgeProfile(profile, appliedSuggestionFields = []) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/profile/publish`,
    { profile, appliedSuggestionFields },
    authConfig(),
  );
  return response.data;
}


export async function uploadKnowledgeFiles(files, sectionKeys = []) {
  const form = new FormData();
  Array.from(files || []).forEach(file => form.append('documents', file));
  form.append('sectionKeys', JSON.stringify(sectionKeys));
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/sources/files`,
    form,
    authConfig(),
  );
  return response.data.knowledgeSources;
}


export async function createKnowledgeUrl(values) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/sources/urls`,
    values,
    authConfig(),
  );
  return response.data.knowledgeSource;
}


export async function createKnowledgeNote(values) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/sources/notes`,
    values,
    authConfig(),
  );
  return response.data.knowledgeSource;
}


export async function updateKnowledgeSource(sourceId, changes) {
  const response = await axios.patch(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}`,
    changes,
    authConfig(),
  );
  return response.data.knowledgeSource;
}


export async function reingestKnowledgeFile(sourceId, sectionKeys) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}/reingest`,
    { sectionKeys },
    authConfig(),
  );
  return response.data.knowledgeSource;
}


export async function getKnowledgeNoteContent(sourceId) {
  const response = await axios.get(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}/content`,
    authConfig(),
  );
  return response.data.content;
}


export async function replaceKnowledgeNote(sourceId, content) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}/replace`,
    { content },
    authConfig(),
  );
  return response.data.knowledgeSource;
}


export async function refreshKnowledgeSource(sourceId) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}/refresh`,
    {},
    authConfig(),
  );
  return response.data.knowledgeSource;
}


export async function deleteKnowledgeSource(sourceId) {
  await axios.delete(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}`,
    authConfig(),
  );
}


export async function getKnowledgeSuggestions(sourceId) {
  const response = await axios.get(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}/suggestions`,
    authConfig(),
  );
  return response.data;
}


export async function getConsolidatedKnowledgeSuggestions() {
  const response = await axios.get(
    `${getBackendHost()}/v2/knowledge/suggestions`,
    authConfig(),
  );
  return response.data;
}


export async function applyKnowledgeSuggestions(sourceId, fields) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}/suggestions/apply`,
    { fields },
    authConfig(),
  );
  return response.data;
}


export async function dismissKnowledgeSuggestions(sourceId, fields) {
  const response = await axios.delete(
    `${getBackendHost()}/v2/knowledge/sources/${sourceId}/suggestions`,
    { ...authConfig(), data: { fields } },
  );
  return response.data.knowledgeSource;
}


export async function dismissAllKnowledgeSuggestions(sectionKey = null, fields = null) {
  const data = {};
  if (sectionKey) data.sectionKey = sectionKey;
  if (fields) data.fields = fields;
  const response = await axios.delete(
    `${getBackendHost()}/v2/knowledge/suggestions`,
    {
      ...authConfig(),
      data,
    },
  );
  return response.data;
}


export async function testKnowledge(question) {
  const response = await axios.post(
    `${getBackendHost()}/v2/knowledge/test`,
    { question },
    authConfig(),
  );
  return response.data.result;
}
